const selectors = {
  trigger: '[data-menu-trigger]',
  menu: '[data-menu-content]',
  close: '[data-menu-close]',
}

class ExpandingMenu extends HTMLElement {
  isOpen = false;
  isMobile = false;
  toggleEvent = 'pointer';

  constructor() {
    super();

    this.toggleMenu = this.toggleMenu.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  connectedCallback() {
    this.menu = this.querySelector(selectors.menu);
    this.trigger = this.querySelector(selectors.trigger);
    this.close = this.querySelector(selectors.close);
    this.interactiveElements = Array.from(this.menu.querySelectorAll('a'));

    if (!this.trigger || !this.menu) return;

    if (this.dataset?.toggleEvent === 'click') {
      this.toggleEvent = 'click';
    }

    this.handleResize();

    setTimeout(() => {
      this.setupEventListeners();
    }, 10);
  }

  handleResize() {
    this.isMobile = window.innerWidth < 800;
  }

  handleKeyDown(e) {
    if ((e.key === 'Escape' || e.key === 'Home') && this.isOpen) {
      this.closeMenu();

      requestAnimationFrame(() => {
        this.trigger.blur();
      });
    }
  }

  setupEventListeners() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('keydown', this.handleKeyDown);
    
    if (this.toggleEvent === 'pointer' && !this.isMobile) {
      this.trigger.addEventListener('pointerenter', this.openMenu);
    }
    
    this.close?.addEventListener('click', this.closeMenu);
    this.trigger?.addEventListener('click', this.toggleMenu);
    this.addEventListener('pointerleave', this.closeMenu);
    
    this.interactiveElements?.forEach(element => {
      element.addEventListener('click', this.closeMenu);
    });
  }

  removeEventListeners() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('keydown', this.handleKeyDown);
    
    if (this.toggleEvent === 'pointer' && !this.isMobile) {
      this.trigger.removeEventListener('pointerenter', this.openMenu);
    }
    
    this.close?.removeEventListener('click', this.closeMenu);
    this.trigger.removeEventListener('click', this.toggleMenu);
    this.removeEventListener('pointerleave', this.closeMenu);

    this.interactiveElements?.forEach(element => {
      element.removeEventListener('click', this.closeMenu);
    });
  }

  toggleMenu(e) {
    if (this.isOpen || e.currentTarget?.tagName === 'A') {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }
  
  openMenu() {
    this.isOpen = true;
    this.menu.setAttribute('data-open', this.isOpen);
    this.trigger.setAttribute('aria-expanded', this.isOpen);
    this.menu.removeAttribute('inert');
  }

  closeMenu() {
    this.isOpen = false;
    this.menu.setAttribute('data-open', this.isOpen);
    this.trigger.setAttribute('aria-expanded', this.isOpen);

    if (!this.isMobile) {
      this.menu.setAttribute('inert', true);
    }
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

if (!customElements.get('expanding-menu')) {
  customElements.define('expanding-menu', ExpandingMenu);
}